import { useAppSelector } from "@/config/store";
import { IEdoQuizAttempt } from "@/shared/model/edo-quiz-attempt.model";
import { IEdoStudent } from "@/shared/model/edo-student.model";
import { AuthenticationState } from "@/shared/reducers/authentication";
import {
  ITEMS_PER_PAGE,
  PaginationState,
} from "@/shared/util/pagination.constants";
import { Card, List, Pagination } from "@/components/ui";
import axios from "axios";
import { useEffect, useState } from "react";
import { Translate } from "react-jhipster";
import AttemptRow from "./AttemptRow";

interface IQuizAttemptsProps {
  student: IEdoStudent;
}

const QuizAttempts = (props: IQuizAttemptsProps) => {
  const { account } = useAppSelector<AuthenticationState>(
    (state) => state.authentication
  );
  const [paginationState, setPaginationState] = useState<PaginationState>({
    activePage: 1,
    itemsPerPage: ITEMS_PER_PAGE,
    sort: "updatedAt",
    order: "ASC",
  });
  const [quizAttempts, setQuizAttempts] = useState<{
    data: IEdoQuizAttempt[];
    loading: boolean;
    totalItems: number;
  }>({ data: [], loading: false, totalItems: 0 });

  const { student } = props;

  const getAllQuizAttempts = async () => {
    setQuizAttempts((prev) => ({ ...prev, loading: true }));
    const response = await axios.get<{
      data: IEdoQuizAttempt[];
      meta: { totalItems: number };
    }>(
      `/parents/${account?.id}/children/${student?.userId}/quiz-attempts`,
      {
        params: {
          page: paginationState.activePage,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        },
      }
    );
    setQuizAttempts({
      data: response.data.data,
      loading: false,
      totalItems: response.data.meta.totalItems,
    });
  };

  useEffect(() => {
    if (account?.id && student?.userId) getAllQuizAttempts();
  }, [
    paginationState.activePage,
    paginationState.order,
    paginationState.sort,
    paginationState.itemsPerPage,
    student?.userId,
    account?.id,
  ]);

  const handlePagination = (currentPage: number) =>
    setPaginationState({ ...paginationState, activePage: currentPage });

  const handleRowsPerPage = (rowsPerPage: number) =>
    setPaginationState({
      ...paginationState,
      itemsPerPage: rowsPerPage,
      activePage: 1,
    });

  return (
    <Card className="flex h-full flex-col overflow-hidden rounded-3xl text-[var(--color-mockup-text-mid)]">
      <div className="flex flex-1 flex-col">
        <div className="border-b border-[var(--color-mockup-border)] px-4 py-3 dark:border-[var(--color-mockup-border)]">
          <h3 className="text-heading font-semibold text-[var(--color-mockup-text)]">
            Risultati test
          </h3>
        </div>
        <div className="min-h-0 flex-1">
          {quizAttempts.loading ? (
            <div className="flex justify-center py-8">
              <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
            </div>
          ) : !quizAttempts.data.length ? (
            <div className="p-4 text-center">
              <span className="text-body text-[var(--color-mockup-text-mid)]">
                <Translate contentKey="edocendoApp.edoQuizAttempt.home.notFound" />
              </span>
            </div>
          ) : (
            <List className="flex flex-col divide-y divide-[var(--color-mockup-border)]">
              {quizAttempts.data.map((quizAttempt) => (
                <AttemptRow key={quizAttempt.id} quizAttempt={quizAttempt} />
              ))}
            </List>
          )}
        </div>
        <Pagination
          count={quizAttempts.totalItems}
          page={paginationState.activePage - 1}
          rowsPerPage={paginationState.itemsPerPage}
          onPageChange={(p) => handlePagination(p + 1)}
          onRowsPerPageChange={handleRowsPerPage}
          labelRowsPerPage="Righe per pagina:"
        />
      </div>
    </Card>
  );
};

export default QuizAttempts;
